import { render, staticRenderFns } from "./UnsendRecord.vue?vue&type=template&id=5903e9bc&scoped=true"
import script from "./UnsendRecord.vue?vue&type=script&lang=js"
export * from "./UnsendRecord.vue?vue&type=script&lang=js"
import style0 from "./UnsendRecord.vue?vue&type=style&index=0&id=5903e9bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5903e9bc",
  null
  
)

export default component.exports